import { useMutation, useQueryClient } from "@tanstack/react-query";
import usePadAPIClient from "./usePadAPIClient";
import {
    DraftWorkshopPad,
    PadAssignment,
    WorkshopPadAssignment,
} from "../../types";
import queryKeys from "./queryKeys";

export const useCreatePadMutation = () => {
    const { postPad } = usePadAPIClient();

    return useMutation((pad: DraftWorkshopPad) => postPad(pad), {
        onSuccess: () => {},
        onError: () => {
            throw new Error(`there was an error useCreatePadMutation`);
        },
    });
};

export const usePostPadAssignment = () => {
    const { postPadAssignment } = usePadAPIClient();
    const queryClient = useQueryClient();

    return useMutation((pad: WorkshopPadAssignment) => postPadAssignment(pad), {
        onSuccess: (data: PadAssignment) => {
            if (!data) return;
            queryClient.setQueryData<PadAssignment[]>(
                queryKeys.getWorkshopPads(data.extra.workshop_id),
                (prevData) => {
                    if (!prevData) return [data];
                    return [...prevData, data];
                }
            );
        },
        onError: (err) => {
            throw new Error(`Error usePostPadAssignment: ${err}`);
        },
    });
};
